import { render, staticRenderFns } from "./UploadDropTile.vue?vue&type=template&id=31107a92&scoped=true"
import script from "./UploadDropTile.vue?vue&type=script&lang=ts"
export * from "./UploadDropTile.vue?vue&type=script&lang=ts"
import style0 from "./UploadDropTile.vue?vue&type=style&index=0&id=31107a92&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31107a92",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31107a92')) {
      api.createRecord('31107a92', component.options)
    } else {
      api.reload('31107a92', component.options)
    }
    module.hot.accept("./UploadDropTile.vue?vue&type=template&id=31107a92&scoped=true", function () {
      api.rerender('31107a92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inbox/UploadDropTile.vue"
export default component.exports